/**
 * Mobile nav functionality.
 */

const mobileNav = function() {
	const $btnOpenNav = $('.js-burger-btn');
	const $btnCloseNav = $('.js-btn-close');
	const $nav = $('.js-nav-mobile');
	const $dropdown = $('.menu__item--has-dropdown');

	function toggleNav(event) {
		event.preventDefault();

		$nav.toggleClass('is-visible');
		$('body').toggleClass('no-scroll nav-visible');
	};

	$btnOpenNav.on('click', toggleNav);
	$btnCloseNav.on('click', toggleNav);

	if ( ! $dropdown ){
		return;
	};

	$dropdown.each(function() {
		const $this = $(this);

		$this.on('click', 'a', function(event) {
			const $menuDropdown = $this.find('.menu__dropdown');

			if ( ! $menuDropdown.is(':visible')) {
				event.preventDefault();

				$menuDropdown.slideToggle(400)
			}
		})
	})
};


mobileNav();
